import Image from 'next/image';
import { NextImageStyleCoverProduct } from '../../BabyNameFinder/styled';
import { Detail, Heading, TypeGrid } from './styled';

export default function Grid(props) {
  const { itemData } = props;
  if (itemData?.content_align == 'bottom' && itemData?.grid_column > 1) {
    return (
      <>
        <TypeGrid
          contentalign={itemData?.content_align}
          gridcoloumn={itemData?.grid_column}
          coloumngap={true}
        >
          {itemData?.widgetContent?.map((item, index) => (
            <div key={`gridWidget${index}`}>
              {item.url && (
                // <ResponsiveImage
                //     src={item.url}
                //     alt={
                //         item?.imageAltName
                //             ? item?.imageAltName
                //             : `${item?.fallbackAltName}  ${itemData.title}`
                //     }
                //     loading="lazy"
                // />
                <NextImageStyleCoverProduct>
                  <Image
                    src={item.url}
                    alt={
                      item?.imageAltName
                        ? item?.imageAltName
                        : `${item?.fallbackAltName}  ${itemData.title}`
                    }
                    loading="lazy"
                    fill
                    sizes="20vw"
                  />{' '}
                </NextImageStyleCoverProduct>
              )}
              {(item.heading || item.body) && (
                <Detail contentalign={itemData?.content_align}>
                  {item.heading ? (
                    <Heading>
                      {' '}
                      <p>{item.heading}</p>
                    </Heading>
                  ) : null}
                  <p> {item.body}</p>
                </Detail>
              )}
            </div>
          ))}
        </TypeGrid>
      </>
    );
  } else {
    return (
      <>
        {itemData?.widgetContent?.map((item, index) => (
          <TypeGrid
            key={`gridWidget${index}`}
            contentalign={itemData?.content_align}
          >
            <NextImageStyleCoverProduct>
              <Image
                src={item.url}
                alt={
                  item?.imageAltName
                    ? item?.imageAltName
                    : `${item?.fallbackAltName}  ${itemData.title}`
                }
                loading="lazy"
                fill
                sizes="20vw"
              />
            </NextImageStyleCoverProduct>

            {(item.heading || item.body) && (
              <Detail contentalign={itemData?.content_align}>
                {item.heading ? (
                  <Heading>
                    {' '}
                    <p>{item.heading}</p>
                  </Heading>
                ) : null}
                <p> {item.body}</p>
              </Detail>
            )}
          </TypeGrid>
        ))}
      </>
    );
  }
}
